import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const {
		logo,
		image,
		title,
		description,
		enterprise,
		linkText,
		link,
		tags,
		impact,
		liveLink,
		liveText,
	} = props;

	return (
		<div className="project">
			{image ? (
				<div className="project-image">
					{liveLink || link ? (
						<a
							href={liveLink || link}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={`Open ${title}`}
						>
							<img
								src={image}
								alt={`${title} preview`}
								loading="lazy"
							/>
						</a>
					) : (
						<img
							src={image}
							alt={`${title} preview`}
							loading="lazy"
						/>
					)}
				</div>
			) : null}
			<div className="project-container">
				{!image && (
					<div className="project-logo">
						<img src={logo} alt="logo" />
					</div>
				)}
				<div className="project-title">{title}</div>
				<div className="project-description">{description}</div>
				{enterprise && (
					<div className="project-enterprise">
						<span className="project-enterprise-label">
							In an enterprise
						</span>
						{enterprise}
					</div>
				)}
				{tags && (
					<div className="project-tags">
						{tags.map((tag, index) => (
							<span key={index} className="project-tag">
								{tag}
							</span>
						))}
					</div>
				)}
				{impact && <div className="project-impact">{impact}</div>}
				<div className="project-links">
					{liveLink && (
						<a
							className="project-link"
							href={liveLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							<span className="project-link-icon">
								<FontAwesomeIcon icon={faExternalLinkAlt} />
							</span>
							<span className="project-link-text">
								{liveText || "Live Demo"}
							</span>
						</a>
					)}
					{link && (
						<a
							className={`project-link${
								liveLink ? " project-link-secondary" : ""
							}`}
							href={link}
							target="_blank"
							rel="noopener noreferrer"
						>
							<span className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</span>
							<span className="project-link-text">
								{linkText || "View Code"}
							</span>
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default Project;
